import React, { useEffect } from 'react'
import { Container, Col, Row } from '@paypalcorp/pp-react'
import { useWindowSize } from '../../../../../hooks/useWindowSize/useWindowSize'
import IconCard from './components/IconCard'
import CouchIcon from '../../../../icons/couchIcon'
import data from '../../../../content/home/home.en-XC.yaml'

import './style.css'

const Resources = () => {
  const { tiles } = data.content.resources || []
  return (
    <section className="tanSection">
      <Container>
        <Row>
          <Col xs={12} md={6} className="floatCol">
            <h3 className="imgHeader">Developer Tools & Resources</h3>
            <CouchIcon width="16" />
          </Col>
          <Col xs={12} md={6} className="floatCol">
            {tiles.map((tile, key) => (
              <IconCard key={key} tile={tile} />
              // <IconLeftLarge
              //   key={key}
              //   border={false}
              //   description={tile.description}
              //   icon={tile.icon}
              //   link={tile.url}
              //   linkText={tile.linkText}
              //   title={tile.title}
              // />
            ))}
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default Resources
